import type { MfaPolicy } from "@/queries/identity/useMfaPolicy";

export const isBreakGlassOwner = (policy: MfaPolicy | undefined): boolean =>
  (policy?.is_required ?? false) && (policy?.can_self_manage ?? true);

export const needsBreakGlassPassword = (policy: MfaPolicy | undefined): boolean =>
  isBreakGlassOwner(policy) && policy?.has_password === false;

export const needsBreakGlassMfa = (policy: MfaPolicy | undefined): boolean =>
  isBreakGlassOwner(policy) && policy?.is_enrolled === false;

export const needsBreakGlassSetup = (policy: MfaPolicy | undefined): boolean =>
  needsBreakGlassMfa(policy) || needsBreakGlassPassword(policy);

export const isBreakGlassReady = (policy: MfaPolicy | undefined): boolean =>
  isBreakGlassOwner(policy) && policy?.is_enrolled === true && policy?.has_password === true;

export type BreakGlassSetupStep = "intro" | "mfa" | "password";

export const getInitialBreakGlassSetupStep = (
  policy: MfaPolicy | undefined,
): BreakGlassSetupStep => {
  if (needsBreakGlassMfa(policy)) {
    return "intro";
  }
  return "password";
};
